import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Subscribes to /clients/strike/admins/{userId}.
 * Returns [loading, isAdmin] where isAdmin is true if the doc exists.
 */
export function useIsStrikeAdmin(userId) {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      setIsAdmin(false);
      return;
    }
    setLoading(true);
    const unsubscribe = firebase
      .firestore()
      .collection('clients')
      .doc('strike')
      .collection('admins')
      .doc(userId)
      .onSnapshot(
        (snap) => {
          setIsAdmin(snap.exists);
          setLoading(false);
        },
        (err) => {
          console.error('[useIsStrikeAdmin] Failed to check admin status:', err);
          setIsAdmin(false);
          setLoading(false);
        },
      );
    return () => unsubscribe();
  }, [userId]);

  return [loading, isAdmin];
}
